export default "__VITE_ASSET__C9LZMa6R__"